(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_editorial-columns-content"] && !Shopify.designMode) return;
  try {
    const initEditorialColumnsDots = (root = document) => {
    const sliders = root.querySelectorAll('[data-editorial-columns-slider]');

    sliders.forEach((slider) => {
      if (slider.dataset.editorialColumnsDotsReady === 'true') return;

      const track = slider.querySelector('[data-editorial-columns-track]');
      const dots = Array.from(slider.querySelectorAll('[data-editorial-columns-dot]'));
      if (!track || dots.length < 2) return;

      const slides = Array.from(track.children).filter((slide) => !slide.hidden);
      if (slides.length < 2) return;

      slider.dataset.editorialColumnsDotsReady = 'true';

      let userHasInteracted = false;
      let raf = 0;
      const setActiveDot = () => {
        raf = 0;
        const trackLeft = track.getBoundingClientRect().left;
        let activeIndex = 0;
        let activeDistance = Infinity;

        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (distance < activeDistance) {
            activeDistance = distance;
            activeIndex = index;
          }
        });

        dots.forEach((dot, index) => {
          if (index === activeIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const resetToFirstSlide = () => {
        if (userHasInteracted) return;
        track.scrollLeft = 0;
        setActiveDot();
      };

      const requestActiveDotUpdate = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(setActiveDot);
      };

      const markInteracted = () => {
        userHasInteracted = true;
      };

      track.addEventListener('pointerdown', markInteracted, { passive: true, once: true });
      track.addEventListener('touchstart', markInteracted, { passive: true, once: true });
      track.addEventListener('wheel', markInteracted, { passive: true, once: true });
      track.addEventListener('keydown', markInteracted, { once: true });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          markInteracted();
          const slideIndex = Number(dot.dataset.editorialColumnsDot || 0);
          const slide = slides[slideIndex];
          if (!slide) return;

          track.scrollTo({
            left: slide.offsetLeft - track.offsetLeft,
            behavior: 'smooth',
          });
        });
      });

      track.addEventListener('scroll', requestActiveDotUpdate, { passive: true });
      window.addEventListener('resize', requestActiveDotUpdate, { passive: true });
      resetToFirstSlide();
      window.requestAnimationFrame(resetToFirstSlide);
      window.setTimeout(resetToFirstSlide, 250);

      if (document.readyState === 'complete') {
        window.setTimeout(resetToFirstSlide, 0);
      } else {
        window.addEventListener('load', resetToFirstSlide, { once: true });
      }
    });
  };

  initEditorialColumnsDots();
  document.addEventListener('shopify:section:load', (event) => initEditorialColumnsDots(event.target));
  } catch(e) { console.error(e); }
})();

})();
